define('views/app/supervisor',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/user',
    'services/viewport',
    'collections/member/supervisors',
    'services/events/user-events',
    // layouts
    'views/app/base-layout',
    'views/app/supervisor/member',
    // views
    'views/modules/member/member-panel',
    'views/modules/conversation/conversation-manager',
    'views/modules/questionnaire/questionnaire-panel',
    'views/modules/template/template-panel',
    'views/modules/setting/setting-panel',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    User,
    Viewport,
    Supervisors,
    UserEvents,
    // Layouts
    VBaseLayout,
    VAppSupervisorMember,
    // views
    VMemberPanel,
    VConversationManager,
    VQuestionnairePanel,
    VTemplatePanel,
    VSettingPanel
) {

    var VSupervisorLayout = VBaseLayout.extend({

        initialize: function(options) {
            var view = this.view = { menu: {}, page: {} };
            this.listenTo(UserEvents, {
                'profile:editFromProfile': this.showClientMenu,
                'onAddClientClick': this.showClientMenu
            });
        },

        menu: {
            profile: function() {
                return [
                    { content: 'Go to Client', callback: this.onSwitchMode, icon: 'sl-icon-logout', id: 'layoutSwitch' },
                    { content: 'Edit my profile', callback: this.onEditProfileAction, icon: 'sl-icon-user' },
                    { content: 'Log out', callback: this.onLogoutAction, icon: 'sl-icon-power' },
                ];
            },
            primary: function() {
                return [
                    { id: 'onboarding', content: 'Onboarding', callback: this.showOnboardingMenu, highlight: true, icon: 'sl-icon-list' },
                    { id: 'clients', content: 'Clients', callback: this.showClientMenu, icon: 'sl-icon-people', },
                    { content: 'Messages', callback: this.showConversationMenu, icon: 'sl-icon-envelope', id: 'message' /* badge: '5' */ },
                    { content: 'Templates', callback: this.showTemplateMenu, icon: 'sl-icon-organization', id: 'template' },
                    { content: 'questionnaire:Questionnaires', callback: this.showFormMenu, icon: 'sl-icon-speech', id: 'questionnaire' },
                    { content: 'Settings', callback: this.showSettingMenu, icon: 'sl-icon-settings', id: 'settings' },
                    { icon: 'sl-icon-question', content: 'Help', callback: this.showHelpMenu }
                ];
            }
        },

        getMemberView: function() {
            var view = this.view.page.member;
            return view || (this.view.page.member = new VAppSupervisorMember({
                model: this.getMember(),
                url: _.clone(this.url.member),
                group: this.getGroup(),
                role: this.role,
            }));
        },

        //////////
        // page //
        //////////
        showMemberPage: function(groupId, userId, pageKey, options) {
            var page = this.view.page;
            if (!page.member) {
                page.member = new VAppSupervisorMember({
                    model: this.getMember(),
                    url: _.clone(this.url.member),
                    group: this.getGroup(),
                    role: this.role,
                });
            }

            this.newConversations.getFirstPage({ unread: true });

            this.when(
                this.setMemberId(userId, { group: groupId }),
                this.setGroupId(groupId),
                User.fetch(),
                Supervisors.fetch(),
            ).then(function() {
                this.getContent().setView(page.member, true);
                page.member.showPage(pageKey, options);
            });

            return this;
        },

        //////////
        // menu //
        //////////

        showOnboardingMenu: function() {
            Backbone.history.navigate("#/" + Mustache.render(this.url.onboarding, { groupId: 'default' }));
            if (Viewport.isMobile()) {
                this.toggleMenuDrawer(false);
            }
        },

        showClientMenu: function() {
            var view = this.view.member;
            if (!view) {
                view = this.view.member = new VMemberPanel({
                    model: this.profile,
                    url: this.url.member.current,
                    role: this.role,
                });
                // this.group.tree.fetch();
            }

            if (! localStorage.getItem('pushNotificationRedirection')) {
                this.setMenuDrawerContent(view);
            } else {
                var urls = JSON.parse(localStorage.getItem('pushNotificationRedirection'));
                Backbone.history.navigate('#/' + urls.supervisor, true);
                localStorage.removeItem('pushNotificationRedirection');
            }
        },

        showConversationMenu: function() {
            var view = this.view.message;
            if (!view) {
                view = this.view.message = new VConversationManager({
                    model: this.profile,
                    group: this.getGroup(),
                    url: this.url.member.message,
                    role: this.role,
                });
            }
            this.setMenuDrawerContent(view);
        },

        showTemplateMenu: function() {
            var view = this.view.template;
            if (!view) {
                view = this.view.template = new VTemplatePanel({
                    model: this.profile,
                    group: this.getGroup(),
                    url: this.url.template,
                    role: this.role,
                });
            }
            this.setMenuDrawerContent(view, true);
        },

        showFormMenu: function() {
            var view = this.view.form;
            if (!view) {
                view = this.view.form = new VQuestionnairePanel({
                    model: this.profile,
                    group: this.getGroup(),
                    url: this.url,
                    role: this.role,
                });
            }
            this.setMenuDrawerContent(view, true);
        },

        showSettingMenu: function() {
            var view = this.view.param;
            if (!view) {
                view = this.view.param = new VSettingPanel({
                    model: User,
                    group: this.getGroup(),
                    url: this.url.member,
                    role: this.role,
                });
            }

            this.setMenuDrawerContent(view);
        },

        /////////////
        // actions //
        /////////////
        onEditProfileAction: function() {
            this.queue.drawer.add(this.showSettingMenu).done(function() {
                this.view.param.showPersonal();
            });
        },

        onSwitchMode: function() {
            UserEvents.switchMode();
            Backbone.history.redirect('#/');
        }
    });

    return VSupervisorLayout;
});

